import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Timezone-agnostic fix: convert UTC to user's local timezone
 * @param utcDateString - UTC date string to convert
 * @returns ISO string in local timezone, or undefined if input is falsy
 */
export function convertUtcToLocalTimezone(utcDateString: string | undefined): string | undefined {
  if (!utcDateString) return utcDateString;
  // Parse as UTC, convert to local timezone, then format as ISO string
  return dayjs.utc(utcDateString).local().toISOString();
}

export const TimezoneService = {
  getFormattedLocalTime(): string {
    const offset = -new Date().getTimezoneOffset();
    const sign = offset >= 0 ? '' : '-';
    const hours = Math.floor(Math.abs(offset) / 60)
      .toString()
      .padStart(2, '0');
    const minutes = (Math.abs(offset) % 60).toString().padStart(2, '0');
    return `${sign}${hours}:${minutes}`;
  },
  getUserLocalTimezoneWithOffset(): string {
    const timezoneName = dayjs.tz.guess();
    const currentTime = dayjs().tz(timezoneName);

    let abbreviation = currentTime.format('z');
    const utcOffset = currentTime.format('Z');

    if (abbreviation === 'z') {
      abbreviation = timezoneName.split('/')[1]?.replace('_', ' ') || 'GMT';
    }

    return `${abbreviation} (UTC${utcOffset})`;
  },
};
